import i18next from "i18next";
import { getLocaleId } from "../constants";
import { AU_CONSTANT } from "./AUConstants";
import { CA_CONSTANT } from "./CAConstants";
import { GB_CONSTANT } from "./GBConstants";
import { US_CONSTANT } from "./USConstants";

export const getAddDays = (days) => {
	const result = new Date();
	result.setDate(result.getDate() + days);
	return result;
};

export const capitalizeFirstLetterForEachWord = (string) =>
	string.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

export const windowScroll = (id) => {
	window.scrollTo({
		top:
			document.getElementById(id).getBoundingClientRect().top +
			window.scrollY -
			(80 + 68),
		behavior: "smooth",
	});
};

export const formatPhoneNumber = (phoneNumber) => {
	return getSiteValueByLocaleId("formatPhoneNumber")(phoneNumber);
};

export const getScrollPosition = (className) => {
	const rdrRoundEdgeElement = document.querySelector(className);
	const rect = rdrRoundEdgeElement.getBoundingClientRect();
	const distanceFromTop = rect.top + window.scrollY - 200;
	return distanceFromTop;
};

export const updateSiteLocaleId = () => {
	const localeId = getLocaleId();
	i18next.changeLanguage(localeId);
};

const siteValueConstant = {
	"en-us": US_CONSTANT,
	"en-au": AU_CONSTANT,
	"en-ca": CA_CONSTANT,
	"en-gb": GB_CONSTANT,
};

export const getSiteValueByLocaleId = (key, value) => {
	const localeId = getLocaleId();
	return value
		? siteValueConstant[localeId][key](value)
		: siteValueConstant[localeId][key];
};

/**
 * @typedef {Object} FormatToLocaleCurrencyOptions
 * @property {number} amountInCents The amount in cents to format
 * @property {"trimZeroCents" | "roundToWhole"} [decimalMode] How to handle decimal places
 */

/**
 * @param {{ localeId: string, currencyCode: string }} param0
 * @returns {(options: FormatToLocaleCurrencyOptions) => string}
 */
export const createCurrencyFormatter =
	({ localeId, currencyCode }) =>
	({ amountInCents, decimalMode = undefined }) => {
		const amountInDollars = amountInCents / 100;

		let maxFractionDigits = 2;
		let minFractionDigits = 2;

		if (decimalMode === "trimZeroCents") {
			// Only removes .00: $19.00 → $19, but $19.50 → $19.50
			if (amountInCents % 100 === 0) {
				maxFractionDigits = 0;
				minFractionDigits = 0;
			}
		} else if (decimalMode === "roundToWhole") {
			// Rounds to whole dollars: $19.50 → $20, $19.99 → $20
			maxFractionDigits = 0;
			minFractionDigits = 0;
		}

		return new Intl.NumberFormat(localeId, {
			style: "currency",
			currency: currencyCode,
			currencyDisplay: "narrowSymbol",
			maximumFractionDigits: maxFractionDigits,
			minimumFractionDigits: minFractionDigits,
		}).format(amountInDollars);
	};

/**
 * @param {FormatToLocaleCurrencyOptions} param0
 */
export const formatToLocaleCurrency = ({
	amountInCents,
	decimalMode = undefined,
}) => {
	const localeId = getSiteValueByLocaleId("localeId");
	const currencyCode = getSiteValueByLocaleId("currencyCode");
	return createCurrencyFormatter({ localeId, currencyCode })({
		amountInCents,
		decimalMode,
	});
};
